<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>{{ i18n.tr("[en]Scheduled Tasks") }}</ion-title>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-list class="task-list">
        <ion-list-header>
            {{ i18n.tr("[en]Tasks for this Month") }}
        </ion-list-header>

        <ion-item *ngFor="let task of scheduledTasks">
            <ion-label>
                <div class="project-container">
                    <span *ngIf="task.projectName" class="project-name"
                        >{{ task.projectName }}</span
                    >
                    <ion-chip *ngIf="task.liproOrderNr">
                        <ion-label>{{ task.liproOrderNr }}</ion-label>
                    </ion-chip>
                </div>
                <h2>{{ task.title }}</h2>
                <p>{{ stripHtmlTags(task.desc) }}</p>

                <div class="task-info-container">
                    <div class="task-schedule">
                        <ion-icon name="calendar-outline"></ion-icon>
                        <ion-label
                            >{{ task.startTime | date: "MMM dd" }}, {{
                            task.startTime | date: "HH:mm" }} - {{ task.endTime
                            | date: "HH:mm" }}</ion-label
                        >
                    </div>
                    <div class="task-deadline" *ngIf="task.dueDate">
                        <ion-icon name="alert-circle-outline"></ion-icon>
                        <ion-label
                            >{{ i18n.tr("[en]Deadline") }}: {{ task.dueDate |
                            date: "MMM dd" }}</ion-label
                        >
                    </div>
                </div>
                <div class="item-actions">
                    <ion-button
                        fill="outline"
                        size="small"
                        color="secondary"
                        (click)="reschedule(task)"
                    >
                        <ion-icon
                            slot="start"
                            name="calendar-outline"
                        ></ion-icon>
                        {{ i18n.tr("[en]Reschedule") }}
                    </ion-button>
                    <ion-button
                        fill="outline"
                        size="small"
                        color="success"
                        (click)="markAsDone(task)"
                    >
                        <ion-icon
                            slot="start"
                            name="checkmark-done-outline"
                        ></ion-icon>
                        {{ i18n.tr("[en]Done") }}
                    </ion-button>
                </div>
            </ion-label>
        </ion-item>
    </ion-list>

    <div
        *ngIf="!scheduledTasks || scheduledTasks.length === 0"
        class="empty-state"
    >
        <ion-icon name="calendar-clear-outline"></ion-icon>
        <ion-label class="ion-text-wrap"
            >{{ i18n.tr("[en]No tasks scheduled for this month.") }}</ion-label
        >
    </div>
    <ion-modal #rescheduleModal cssClass="card-modal">
        <ng-template>
            <ion-header>
                <ion-toolbar>
                    <ion-buttons slot="start">
                        <ion-button (click)="cancelReschedule()"
                            >{{ i18n.tr("[en]Cancel") }}</ion-button
                        >
                    </ion-buttons>
                    <ion-title>{{ i18n.tr("[en]Reschedule Task") }}</ion-title>
                    <ion-buttons slot="end">
                        <ion-button
                            (click)="confirmReschedule()"
                            [strong]="true"
                            >{{ i18n.tr("[en]Confirm") }}</ion-button
                        >
                    </ion-buttons>
                </ion-toolbar>
            </ion-header>
            <ion-content class="ion-padding">
                <ion-datetime
                    #reschedulePicker
                    presentation="date-time"
                    [value]="taskToReschedule?.startTime.toISOString()"
                    [highlightedDates]="dateHighlights"
                ></ion-datetime>
                <div class="legend-container">
                    <div class="legend-item">
                        <span class="legend-dot busy"></span>
                        <ion-label
                            >{{ i18n.tr("[en]Busy") }} (1-2 tasks)</ion-label
                        >
                    </div>
                    <div class="legend-item">
                        <span class="legend-dot full"></span>
                        <ion-label
                            >{{ i18n.tr("[en]Full") }} (3+ tasks)</ion-label
                        >
                    </div>
                </div>
            </ion-content>
        </ng-template>
    </ion-modal>
</ion-content>
